import { render } from "./StepTwo.vue?vue&type=template&id=af0a399a&scoped=true"
import script from "./StepTwo.vue?vue&type=script&lang=js"
export * from "./StepTwo.vue?vue&type=script&lang=js"

import "./StepTwo.vue?vue&type=style&index=0&id=af0a399a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af0a399a"]])

export default __exports__